import {InputTypes, ValueTypes, IFieldDefinition, FieldViews} from 'app/interfaces';
import { Validators } from '@angular/forms';
import * as moment from 'moment';
import { IDataContainerService } from 'app/interfaces/data-container.interface';

const fieldsMap: Map<string, IFieldDefinition> = new Map();

fieldsMap.set('message', {
	key: 'message',
	name: 'Pacchetto',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING,
	formValidators: [ Validators.required ]
});

fieldsMap.set('created_at', {
	key: 'created_at',
	name: 'Data azione',
	inputType: InputTypes.DATETIME,
	valueType: ValueTypes.DATETIME,
	formValidators: [ Validators.required ]
});

export {fieldsMap};
